import type { Role } from '../../../types/Role';
import { EnquiryType, OfferModel } from '../model/OfferModel';
import { OfferState } from '../model/OfferState';

interface OfferChatAccessState {
    showForwardedOfferInfoText: boolean;
    showInfoText: boolean;
    isMessagingAllowed: boolean;
}

const messagingAllowedFinishedStates = new Set([
    OfferState.DELIVERED,
    OfferState.DELIVERY_CONFIRMED,
    OfferState.INVOICED,
]);

export const getOfferChatAccessState = (offer: OfferModel, role: Role): OfferChatAccessState => {
    const hasWriteRights = role.hasWriteRights(offer.customerId) || role.hasWriteRights(offer.supplierId);
    const isNonPlatformSupplier =
        offer.enquiryType === EnquiryType.FORWARDED || offer.enquiryType === EnquiryType.ANONYMOUS;
    const showForwardedOfferInfoText = role.isCustomer() && isNonPlatformSupplier;
    const showInfoText =
        role.isSupplier() &&
        offer.enquiryType === EnquiryType.SPOT &&
        offer.state === OfferState.ENQUIRY &&
        !offer.wasQuoted();
    const showAnyInfoText = showForwardedOfferInfoText || showInfoText;
    const isMessagingAllowedForState = !offer.isFinished() || messagingAllowedFinishedStates.has(offer.state);

    return {
        showForwardedOfferInfoText,
        showInfoText,
        isMessagingAllowed: !role.isSuperAdmin() && hasWriteRights && !showAnyInfoText && isMessagingAllowedForState,
    };
};
